import { render, staticRenderFns } from "./RecentProjects.vue?vue&type=template&id=7049b6ae&scoped=true"
import script from "./RecentProjects.vue?vue&type=script&lang=js"
export * from "./RecentProjects.vue?vue&type=script&lang=js"
import style0 from "./RecentProjects.vue?vue&type=style&index=0&id=7049b6ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7049b6ae",
  null
  
)

export default component.exports